module.exports = __webpack_public_path__ + "3a21fdde.svg";